<div class="block request-state">
  <div class="title-wrapper request-state__mb-32">
    <h3 class="title">Estado do pedido</h3>
    <app-state-label
      [label]="viewModel?.state"
      [background]="viewModel?.stateStyle?.bgState"
      [color]="viewModel?.stateStyle?.colorState"
    >
    </app-state-label>
  </div>

  <div *ngIf="viewModel?.displayForm">
    <div class="request-state__mb-32">
      <scc-dsm3-textarea-control
        [formGroup]="viewModel?.formGroup"
        placeholder="Descreva aqui o pedido"
        [maxlength]="99999"
        [formName]="viewModel?.formNameDescription"
        [errorsMessage]="viewModel?.errorsMessageDescription"
        [counter]="false"
      >
      </scc-dsm3-textarea-control>
    </div>

    <div class="request-state__mb-32">
      <h3 class="title">Anexos</h3>
      <dsm34-form-field>
        <dsm34-upload
          [multiple]="true"
          [formControl]="$any(viewModel?.formGroup.get('attachments'))"
          [fileList]="uploadFilelist"
          [maxSizeAccepted]="3670016"
          [accept]="fileTypes"
          (errorList)="showErrors($event)"
        >
          <h1 title>Clique para Carregar</h1>
          <p content>
            Pode anexar múltiplos ficheiros do tipo pdf, jpg, jpeg, png, xlsx, csv, doc, docx, sgl, sgl_v2, zip. Cada
            ficheiro deverá ter no máximo 2MB.
          </p>
        </dsm34-upload>
      </dsm34-form-field>

      <dsm34-filelist
        #uploadFilelist
        [files]="$any(viewModel?.formGroup.get('attachments')).value"
        class="dsm34--mt-md"
        direction="column"
      >
        <ng-template dsm34ImplicitTemplate let-file>
          <dsm34-svg name="documentacao" color="main-yellow" size="lg" />

          <div class="dsm34--d-flex dsm34--flex-column dsm34--flex-fill">
            <div class="dsm34-highlight-small--book">{{ file.name }}</div>
            <span class="dsm34-body-2--regular dsm34--neutral-dark-grey">
              {{ file | dsm34FileSize }}
            </span>
          </div>

          <div>
            <button type="button" dsm34-button class="dsm34--ml-none" round (click)="uploadFilelist.onRemove(file)">
              <dsm34-svg name="apagar" size="md" />
            </button>
          </div>
        </ng-template>
      </dsm34-filelist>
    </div>

    <div class="button-wrapper">
      <button class="btn-white-bggrey" (click)="back()">Voltar</button>
      <button
        class="btn-primary-yellow"
        (click)="submitAction()"
        [disabled]="!validForm || !viewModel?.canUpdateRequest"
      >
        Submeter
      </button>
    </div>
  </div>

  <div *ngIf="viewModel?.messageListViewModel">
    <app-message-list [viewModel]="viewModel?.messageListViewModel" (clickItem)="downloadAttachment($event)">
    </app-message-list>
  </div>
</div>
